import { CallToActionSplit } from "../../../../modules/content/components/CallToActionSplit/CallToActionSplit";
import { CallToActionStacked } from "../../../../modules/content/components/CallToActionStacked/CallToActionStacked";
import { VelvetSection } from "../../../../modules/content/components/VelvetSection/VelvetSection";
import type { ICallToActionBlockProps } from "./CallToActionBlock.props";

export const CallToActionBlock = (props: ICallToActionBlockProps) => {
  const { anchorId, buttons, description, eyebrow, heading, image, parentClass, spacing, variant } =
    props;
  if (!eyebrow && !heading && !description && !buttons?.length && !image) return null;

  return (
    <VelvetSection className={parentClass} id={anchorId} spacing={spacing}>
      <div className="relative overflow-hidden border-y border-parchment/25 py-10 text-parchment before:absolute before:bottom-0 before:left-1/4 before:top-0 before:w-px before:bg-thread/40 md:py-16 lg:py-24">
        {variant === "split" ? (
          <CallToActionSplit {...props} />
        ) : (
          <CallToActionStacked {...props} />
        )}
      </div>
    </VelvetSection>
  );
};

CallToActionBlock.displayName = "Block::CallToActionBlock";
